/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItem from '../../components/ContentItemEnd';

class PopularContent extends Component {
  state = {
    menuIndex: 0,
    slideIndex: 1,
    slidePlay: true,
    mouseOn: false,
    onEvent: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getContent('/pupulaMonth');
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getContent = async (api) => {
    // const { loginId } = this.props;

    const result = await this._getContentApi(api);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          contentList,
        });
      }
    }
  };
  _getContentApi = (api) => {
    const { apiUrl, loginId } = this.props;

    return axios(apiUrl + api + '?userid=' + loginId)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <ContentItem
          key={index}
          contentSerial={item.contentSerial}
          title={item.title}
          genreName={item.genreName}
          img={item.img}
          overImg={item.overImg}
          restrictionCode={item.restrictionCode}
          opening={item.opening}
          director={item.director}
          contentSysnopsis={item.contentSysnopsis}
          dRank={item.dRank}
          viewCnt={item.viewCnt}
          wishFlag={item.wishFlag}
          contentPartSerial={item.contentPartSerial}
          num={index + 1}
          onEndItemSlide={this._onEndItemSlide}
          subTitle={item.subTitle}
          cashOnly={item.cashOnly}
        />
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    const { slideIndex } = this.state;
    let scrollPos;
    ////console.log(slideIndex)
    if (num === null || num === '' || num === undefined) {
      //console.log()
    } else {
      //console.log(over, num, slideIndex)
      if (over) {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 1;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 7;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 13;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 19;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      } else {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 0;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 6;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 12;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 18;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      }
    }
  };

  _onToggleMouseOn = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onSelect = (key) => {
    //console.log(key)
  };
  _arrowNext = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    const page = Math.round(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentList.length;
    // const page = Math.round(cnt / 6);

    //if(slideIndex < 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _renderDot = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }
    //console.log(page, cnt)
    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _onMonthContent = () => {
    //console.log('aaa')
    this.setState({
      menuIndex: 0,
    });
    this._getContent('/pupulaMonth');
  };
  _onQuaterContent = () => {
    //console.log('bbb')
    this.setState({
      menuIndex: 1,
    });
    this._getContent('/pupulaQuater');
  };
  render() {
    const { contentList, mouseOn, slideIndex, menuIndex } = this.state;
    return (
      <Fragment>
        {contentList ? (
          <div className="main_list_style m_thumblist">
            <h1>
              <strong>인기 작품</strong>
              <span
                style={{ cursor: 'pointer' }}
                onClick={this._onMonthContent}
                className={menuIndex === 0 ? 'on' : null}
              >
                월별
              </span>
              <span
                style={{ cursor: 'pointer' }}
                onClick={this._onQuaterContent}
                className={menuIndex === 1 ? 'on' : null}
              >
                분기별
              </span>
              <div>
                {this._renderDot()}
                {/*<a href="#">더보기</a>*/}
              </div>
            </h1>

            <div
              className="main_list_goup1"
              onMouseEnter={this._onToggleMouseOn}
              onMouseLeave={this._onToggleMouseOff}
            >
              {/*<a href="#" className="left_btn"><span>이전</span></a>
                        <a href="#" className="right_btn"><span className="on">다음</span></a>*/}
              {/*리스트 오브 시 좌우 버튼 생김*/}
              <div className="div_ul">
                <ScrollMenu
                  data={contentList ? this._renderItem() : null}
                  arrowLeft={
                    mouseOn ? (
                      slideIndex === 1 ? null : (
                        <a
                          className="left_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowPrev}
                        >
                          <span className={'on'}>이전</span>
                        </a>
                      )
                    ) : null
                  }
                  arrowRight={
                    mouseOn ? (
                      slideIndex > parseInt(contentList.length / 6) ? null : (
                        <a
                          className="right_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowNext}
                        >
                          <span className={'on'}>다음</span>
                        </a>
                      )
                    ) : null
                  }
                  wheel={false}
                  dragging={true}
                  transition={0.5}
                  translate={2}
                  alignOnResize={true}
                  //inertiaScrolling={true}
                  //inertiaScrollingSlowdown={3}
                  //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                  alignCenter={false}
                  hideSingleArrow={true}
                  hideArrows={mouseOn}
                  onUpdate={(t) => {
                    if (t) {
                      //console.log(t)
                    }
                  }}
                  ref={(ref) => (this.scrollMenu = ref)}
                  scrollBy={6}
                  //innerWrapperStyle={{textAlign: 'center'}}
                  //onSelect={this._onSelect}
                  //selected={selected}
                />
              </div>
              <div className="clear"></div>
            </div>

            {/*
                    <div className="main_list_goup3">
                        <div className="div_ul">
                            { contentList ? this._renderItem() : null}
                        </div>
                        <div className="clear"></div>
                    </div>
                    */}
          </div>
        ) : null}
        {/*
                <div>
                    { contentList ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(PopularContent));
